import axios from "axios";
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { ClipLoader } from "react-spinners";
import Top from "../components/Top";
import Navbar from "../components/Navbar";

const ForgotPassword = ({ currentUser }) => {
  const [loading, setLoading] = useState(false);
  const [codeSent, setCodeSent] = useState(false)
  const [codeVerified, setCodeVerifed] = useState(false)

  const [email, setEmail] = useState()
  const [code, setCode] = useState()

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const [serverError] = useState("");
  const navigate = useNavigate();

  const onSubmit = async (data) => {
    setLoading((prev) => !prev);
    if (!codeSent && !codeVerified) {
      try {
        let response = await axios.post(
          `${import.meta.env.VITE_REACT_APP_BACKEND_BASEURL
          }/api/v1/user/forgot-password`,
          data,
          { withCredentials: true }
        );
        setEmail(data.email)
        setLoading((prev) => !prev);
        toast.success(response.data.message);
        setCodeSent(true)
      } catch (error) {
        setLoading(false);
        toast.error(error.response.data.message);
      }
    } else if (codeSent && !codeVerified) {
      try {
        let response = await axios.post(
          `${import.meta.env.VITE_REACT_APP_BACKEND_BASEURL
          }/api/v1/user/verify-code`,
          {
            code: data.code,
            email
          },
          { withCredentials: true }
        );

        setLoading((prev) => !prev);
        toast.success(response.data.message);
        setCodeSent(true)
        setCodeVerifed(true)
        setCode(data.code)
      } catch (error) {
        setLoading(false);
        toast.error(error.response.data.message);
      }
    } else {
      try {
        let response = await axios.post(
          `${import.meta.env.VITE_REACT_APP_BACKEND_BASEURL
          }/api/v1/user/reset-password`,
          {
            code,
            email,
            newPassword: data.newPassword,
            confirmPassword: data.confirmPassword
          },
          { withCredentials: true }
        );

        setLoading((prev) => !prev);
        toast.success(response.data.message);
        setCodeSent(true)
        setCodeVerifed(true)
        setCode(data.code)
        navigate("/login")
      } catch (error) {
        setLoading(false);
        toast.error(error.response.data.message);
      }
    }
  };

  return (
    <div className="py-6 px-3 xl:px-8">
      {/* <Top currentUser={currentUser} />
      <Navbar currentUser={currentUser} /> */}

      <div className="bg-white rounded-lg px-0 xl:px-8 sm:px-6 p-8 pt-0 mt-6 w-full sm:w-[450px] xl:w-[520px] mx-auto">
        <h2 className=" font-semibold text-[24px] xl:text-[32px] 2xl:text-[36px] xxl:text-4xl  leading-none tracking-normal text-[#5D0E23]">
          {!codeVerified && !codeSent ? "Enter email" : (!codeVerified && codeSent ? "Enter Code" : "Set Password")}
        </h2>
        <p>{!codeVerified && !codeSent ? "Please enter email so we can send code to reset password" : (!codeVerified && codeSent ? "Please enter the code we sent on mail" : "Please set the new password.")}</p>

        {serverError && (
          <p className="text-red-500 text-center mb-4">{serverError}</p>
        )}

        <form
          className="mt-4 2xl:mt-5 flex flex-col gap-2"
          onSubmit={handleSubmit(onSubmit)}
        >
          {
            !codeSent && !codeVerified &&
            <div className="mb-2">
              <input
                onChange={(e) => setEmail(e.target.value)}
                type="email"
                id="email"
                {...register("email", {
                  required: "Email is required.",
                })}
                className={`text-[12px] xl:text-[16px] appearance-none border border-[#797979]  rounded w-full py-3 px-5 text-[#47474A] leading-tight focus:outline-none  ${errors.email ? "border-red-500" : ""
                  }`}
                placeholder="Enter email"
              />
              {errors.email && (
                <p className="text-red-500 text-xs italic">
                  {errors.email.message}
                </p>
              )}
            </div>
          }
          {
            codeSent && !codeVerified &&
            <div className="mb-2">
              <input
                onChange={(e) => setCode(e.target.value)}
                type="code"
                id="code"
                {...register("code", {
                  required: "Code is required.",
                })}
                className={`text-[12px] xl:text-[16px] appearance-none border border-[#797979]  rounded w-full py-3 px-5 text-[#47474A] leading-tight focus:outline-none  ${errors.code ? "border-red-500" : ""
                  }`}
                placeholder="Enter code"
              />
              {errors.code && (
                <p className="text-red-500 text-xs italic">
                  {errors.code.message}
                </p>
              )}
            </div>
          }
          {
            codeSent && codeVerified &&
            <div>
              <div className="mb-2">
                <input
                  onChange={(e) => setCode(e.target.value)}
                  type="password"
                  id="newPassword"
                  {...register("newPassword", {
                    required: "New password is required.",
                  })}
                  className={`text-[12px] xl:text-[16px] appearance-none border border-[#797979]  rounded w-full py-3 px-5 text-[#47474A] leading-tight focus:outline-none  ${errors.newPassword ? "border-red-500" : ""
                    }`}
                  placeholder="Enter new password"
                />
                {errors.newPassword && (
                  <p className="text-red-500 text-xs italic">
                    {errors.newPassword.message}
                  </p>
                )}
              </div>
              <div className="mb-2">
                <input
                  onChange={(e) => setCode(e.target.value)}
                  type="password"
                  id="confirmPassword"
                  {...register("confirmPassword", {
                    required: "Confirm Password is required.",
                  })}
                  className={`text-[12px] xl:text-[16px] appearance-none border border-[#797979]  rounded w-full py-3 px-5 text-[#47474A] leading-tight focus:outline-none  ${errors.confirmPassword ? "border-red-500" : ""
                    }`}
                  placeholder="Enter confirm password"
                />
                {errors.confirmPassword && (
                  <p className="text-red-500 text-xs italic">
                    {errors.confirmPassword.message}
                  </p>
                )}
              </div>
            </div>
          }

          <div className="flex items-center justify-center">
            <button
              type="submit"
              className="cursor-pointer  font-semibold text-[20px] xl:text-[18px] rounded-[6px] xl:rounded-[6px] mt-2 2xl:mt-3 2xl:rounded-[8px] xxl:rounded-[10px] 2xl:text-[20px] xxl:text-2xl leading-none tracking-normal bg-[#7F132F] w-[55%] hover:bg-[#55051A] text-white py-3 focus:outline-none "
            >
              {loading ? <ClipLoader size={"1em"} color="white" /> : !codeVerified && !codeSent ? "Send Code" : (!codeVerified && codeSent ? "Submit" : "Change Password")}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ForgotPassword;
